import React from "react";
import { useHistory } from "react-router-dom";

import { Button } from "reactstrap";

const Page500 = () => {
  const history = useHistory();
  return (
    <div className="text-center">
      <h1 className="display-1 font-weight-bold">500</h1>
      <p className="h1">Error de servidor.</p>
      <p className="h2 font-weight-normal mt-3 mb-4">
        El servidor encontró algo inesperado que no le permitió completar la
        solicitud.
      </p>
      <Button onClick={() => history.push("/feed")} color="primary" size="lg">
        Volver al sitio web
      </Button>
    </div>
  );
};

export default Page500;
